<template>
  <f7-page name="recommendfriend">
    <bc-navbar></bc-navbar>
    <div class="page_single layout_fullwidth_padding">
      <ReferralMainComponent
        :title="title"
        :description="description"
        :customization="customization"
        :sharedLinkData="sharedLinkData"
        :loading="loading"
        @share="onShare($event)"
        @next="onNext($event)"
      />
    </div>
    <loader :show="loading" />
  </f7-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ReferralMainComponent from '@components/referral/referral-main.vue'
import Loader from '@components/loader.vue'
import { notify } from '@/shared/notifications.js'
import { openSMSEditor } from '@/helpers/sms-editor.js'
/* eslint-disable */

export default {
  name: "recomend-friend",
  components: {
    ReferralMainComponent,
    Loader,
  },
  mounted: async function() {
    this.loading = true;
    await this.getInfo();
    await this.getSharedLink();
    this.loading = false;
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization,
    }),
    ...mapGetters({
      title: "recommendFriend/title",
      description: "recommendFriend/description",
      sharedLinkData: "recommendFriend/sharedLinkData",
    }),
  },
  methods: {
    ...mapActions({
      getInfo: "recommendFriend/getInfo",
      invite: "recommendFriend/invite",
      getSharedLink: "recommendFriend/getShareLink",
      sendSharedLink: "recommendFriend/sendSharedLink",
      addReferral: "recommendFriend/addReferral",
      getReferralMessage: 'recommendFriend/getReferralMessage',
      sendSmsAction: "recommendFriend/sendSmsAction"
    }),
    async onShare() {
      const { link, title } = this.sharedLinkData;
      try {
        navigator
          .share({
            url: link,
            title: title,
          })
          .then(() => this.onShareResult());
      } catch (err) {
        notify.error("Error during share proccess");
      }
    },
    async onNext(data) {
      this.referral = data.referral;
      this.loading = true;
      const referralRes = await this.addReferral({
        refferals:[{
        fullName: this.referral.name,
        phone: this.referral.phone,
      }]
      })

      if(!referralRes || !referralRes.success){
        this.loading = false;
        return;
      }

      const referralCode = referralRes.model[0].referralCode
      const referralMessageRes = await this.getReferralMessage(referralCode)

      if(!referralMessageRes || !referralMessageRes.success){
        this.loading = false;
        notify.error("Get referral link error");
        return;
      }

      const text = referralMessageRes.model;

      this.loading = false;
      openSMSEditor(this.referral.phone, text);
      try {
        await this.sendSmsAction(referralCode)
      } catch (error) {
        console.error(error)
        notify.error(error.message)
      }
      data.onSuccess();
      notify.success("Message was sent successfully!");
    },
    onShareResult() {
      this.sendSharedLink().then(() => {
        notify.success("Link shared successfully!");
      });
    },
  },
  data() {
    return {
      referral: null,
      code: null,
      loading: false,
    };
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// recommend-friend.vue?e6190e9c